import React from "react"
import { Navigate, useLocation } from "react-router-dom"
import Box from "@mui/material/Box"
import { useAuth } from "./AuthContext"

function PageLoader() {
  return (
    <Box
      sx={{
        height: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        backgroundColor: "var(--app-bg)",
      }}
    />
  )
}

export default function ProtectedRoute({ children }) {
  const { user, loading } = useAuth()
  const location = useLocation()

  if (loading) return <PageLoader />
  if (!user) return <Navigate to={`/login?from=${encodeURIComponent(location.pathname)}`} replace />
  return children
}
